import { render, staticRenderFns } from "./error.vue?vue&type=template&id=407b905e"
import script from "./error.vue?vue&type=script&setup=true&lang=ts"
export * from "./error.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CBtnTertiary: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/components/CBtnTertiary/CBtnTertiary.vue').default,CRow: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CGrid/CRow.vue').default,LtkDiscoverFeed: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/Ltk/LtkDiscoverFeed.vue').default,CContainer: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CGrid/CContainer.vue').default})
